<template>
  <div class="container">
    <Message :show="message.msg" :message="message" />
    <Label text="Clave de Acceso" header="header-2"/>
    <Apis v-if="user.access" :details="user.access" />
    <Label text="Resumen de Peticiones" header="header-3"/>
    <DataTable v-if="total_lines > 0" :fields="fields" :inputData="recordsData" />
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';

import Apis from '../components/Apis';
import DataTable from '../components/DataTable';
import Label from '../components/Label';
import Message from '../components/Message';

export default {
    name: 'Request',
    components: {
      Apis,
      DataTable,
      Label,
      Message
    },
    data: function() {
      return {
        user: {},
        axiosParams: {},
        total_lines: 0,
        recordsData: [],
        fields: {
            id: {
                label: 'ID',
                sortable: true
            },
            createdAt: {
                label: 'REALIZADO',
                sortable: true
            },
            method: {
                label: 'MÉTODO',
                sortable: false
            },
            url: {
                label: 'URL',
                sortable: false
            },
            items: {
                label: 'ELEMENTOS',
                sortable: false
            }
        },
        message: {},
      };
    },
    created: function() {
        const lsUser = Vue.localStorage.get('user');
        if (lsUser) {
          this.user = JSON.parse(lsUser);
          this.axiosParams = {
            headers: {
              'Authorization': this.user.access.key
            }
          }
          this.getRequestByUser();
        }
    },
    methods: {
      getRequestByUser : async function() {
        var vm = this;
        var url = process.env.VUE_APP_HOST + process.env.VUE_APP_PATH_API + 'requests/' + vm.user.id;
        await axios.get(url, vm.axiosParams).then(function(response) {
            vm.recordsData = [];
            response.data.forEach((item) => {
              var obj = {
                id: item.id,
                createdAt: moment(item.createdAt,'YYYY-MM-DDTHH:mm:ss.SSSSZ', true).format('YYYY-MM-DD HH:mm:ss'),
                method: item.method,
                url: item.url,
                items: item.response.length,
                response: item.response
              }
              vm.recordsData.push(obj);
            });
            vm.total_lines = vm.recordsData.length;
        }).catch(function(error) {
            vm.message = {
              msg: error,
              variant: 'danger',
              dismiss: 4
            }
            console.log(error);
        });
      }
    }
}
</script>
